<template>
  <div v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_liabilitities_report')">
    <row id="totalvisits_row">
      <div class="col-md-12">
        <div v-if="!isShowReportChart" style="display:inline-block;">
          <p
            @click="onClickApartmentType(1)"
            :class="
              apartmentType == 1
                ? 'btn-change-apartment-type-selected'
                : 'btn-change-apartment-type'
            "
          >
            {{ $t("reportLiabilitiesReport.apartmentsForStay") }}
          </p>
          <p
            @click="onClickApartmentType(2)"
            :class="
              apartmentType == 2
                ? 'btn-change-apartment-type-selected'
                : 'btn-change-apartment-type'
            "
          >
            {{ $t("reportLiabilitiesReport.apartmentsForRent") }}
          </p>
        </div>
        <div class="row">
          <div v-if="!isShowReportChart" class="col-md-3">
            <div class="form-group">
              <label>{{
                $t("reportLiabilitiesReport.selectDetailReportType")
              }}</label>
              <lte-select2
                :options="detailReportTypes"
                @change="onSelectDetailReportType"
                :defaultSelected="1"
              >
              </lte-select2>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>{{
                $t("reportLiabilitiesReport.chooseTypeReport")
              }}</label>
              <lte-select2
                :options="reportTypeList"
                @change="onSelectReportType"
                :defaultSelected="1"
              >
              </lte-select2>
            </div>
          </div>
        </div>
        <div v-if="detailReportTypeId == 1" class="box box-info">
          <div class="box-header with-border">
            <div class="col-md-3">
              <h3 class="box-title">
                {{ $t("reportLiabilitiesReport.synthesisReport") }}
              </h3>
            </div>
            <div class="col-md-9">
              <div class="col-md-6 col-sm-6 col-xs-12">
                <!-- Date range -->
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label>{{ $t("reportLiabilitiesReport.startDate") }}</label>
                    <date-picker
                      @dp-change="changeDateTime($event)"
                      class="form-control"
                      v-model="eventdata.start_datetime"
                      :config="optionsStart"
                    ></date-picker>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label>{{ $t("reportLiabilitiesReport.endDate") }}</label>
                    <date-picker
                      @dp-change="changeDateTime($event)"
                      class="form-control"
                      v-model="eventdata.end_datetime"
                      :config="optionsEnd"
                    ></date-picker>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 col-xs-12">
                <!-- /.form group -->
                <div class="form-group">
                  <label>{{
                    $t("reportLiabilitiesReport.chooeTypeService")
                  }}</label>
                  <lte-select2
                    :options="serviceTypeList"
                    @change="onSelectServiceType"
                    :defaultSelected="0"
                  >
                  </lte-select2>
                </div>
                <!-- /.form-group -->
              </div>
            </div>
            <lte-button
              style="float:right;background-color:white !important;margin-right:15px"
              type="btn btn-default"
              right_icon="fa fa-download"
              @click="onExport($event)"
              v-if="
                has_perm('export_liabilitities_report') ||
                  GET_ACCOUNT_DATA.id == 1
              "
              >{{ $t("customer.export") }}</lte-button
            >
          </div>
          <div class="box-body">
            <div class="chart" v-show="isShowReportChart">
              <lte-chart :chartConfig="totalVisitChartConfig"> </lte-chart>
            </div>
            <div class="col-md-12" v-if="!isShowReportChart">
              <b-table
                style="white-space: nowrap;"
                responsive
                :busy="isLoading"
                selectable
                @row-selected="myRowClickHandler"
                :select-mode="'single'"
                :items="columnData"
                :fields="column_fields"
                class="mt-3"
                bordered
                outlined
              >
                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>{{ $t("reportLiabilitiesReport.loading") }}</strong>
                  </div>
                </template>
                <!-- <template
                  v-for="index in column_fields"
                  :slot="'HEAD_' + index.key"
                  slot-scope="item"
                >
                  {{ $t(item.label) }}
                </template> -->
                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
                <template slot="target" slot-scope="row">
                  <a
                    :href="row.item.url"
                    target="_blank"
                    :id="`segment_target_${row.item.id}`"
                    >{{ row.item.target }}</a
                  >
                  <tooltip
                    :text="row.item.url"
                    :target="`#segment_target_${row.item.id}`"
                  />
                </template>
                <template slot="actions" slot-scope="row">
                  <div class="btn-group">
                    <button
                      class="btn btn-primary btn-sm"
                      style="margin-left: 6px;"
                      @click="viewDetailReport(row)"
                    >
                      <i class="glyphicon glyphicon-list-alt"></i>
                    </button>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <!-- Detailed Report By Each Month -->
      <div v-if="detailReportTypeId == 2" class="col-md-12">
        <detailed-report-by-each-month
          v-if="!isShowReportChart"
          ref="detailedReportEachMonth"
          :apartment_type="apartmentType"
        ></detailed-report-by-each-month>
      </div>
      <!-- Detailed Report Of Each Unit For A Month -->
      <div v-if="detailReportTypeId == 3" class="col-md-12">
        <detailed-report-of-each-unit-for-a-month
          v-if="!isShowReportChart"
          ref="detailedReportAMonth"
          :apartment_type="apartmentType"
        ></detailed-report-of-each-unit-for-a-month>
      </div>
    </row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTEChart from "@/components/LTEChart";
import LTEButton from "@/components/LTEButton.vue";
import datePicker from "vue-bootstrap-datetimepicker";
// import DateRangePicker2 from '@/components/LTEDateRangePicker2.vue'
import Select2 from "@/components/LTESelect2Input.vue";
import utils from '@/lib/utils';
import XLSX from "xlsx";
import moment from "moment";
import DetailedReportByEachMonth from "./DetailedReportByEachMonth";
import DetailedReportOfEachUnitForAMonth from "./DetailedReportOfEachUnitForAMonth";

export default {
  name: "LiabilitiesReport",
  data() {
    return {
      columnData: [
        { id: 1, "Tình trạng": this.$t("reportLiabilitiesReport.paid") },
        { id: 3, "Tình trạng": this.$t("reportLiabilitiesReport.open") },
        { id: 2, "Tình trạng": this.$t("reportLiabilitiesReport.receivable") }
      ],
      column_fields: [{ key: "Tình trạng", label: "", class: "text-right" }],
      dateArray: [],
      apartmentMonthlyUsageStatusList: [
        {
          text: this.$t("report.chooseServiceStatus"),
          id: 0
        }
      ],
      reportTypeList: [
        {
          text: "Hiển thị theo chart",
          id: 1
        },
        {
          text: "Hiển thị theo bảng",
          id: 2
        }
      ],
      detailReportTypes: [
        {
          text: "Tổng Hợp",
          id: 1
        },
        {
          text: "Chi Tiết Các Căn Chưa Thu Theo Từng Tháng",
          id: 2
        },
        {
          text: "Chi Tiết Từng Căn Cho Một Tháng",
          id: 3
        }
      ],
      serviceTypeList: [
        {
          text: this.$t("reportLiabilitiesReport.allService"),
          id: 0
        },
        {
          text: this.$t("reportmonthly.electric"),
          id: 1
        },
        {
          text: this.$t("reportmonthly.water"),
          id: 2
        },
        {
          text: this.$t("reportLiabilitiesReport.managementService"),
          id: 7
        }
      ],
      selectedDate: {
        start: "",
        end: ""
      },
      totalVisitChartConfig: {
        type: "bar",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          onClick: this.onLick,
          responsive: true,
          pointDot: true,
          pointDotRadius: 4,
          pointDotStrokeWidth: 1,
          legend: {
            display: true,
            position: "top",
            labels: {
              usePointStyle: true
            }
          },
          tooltips: {
            mode: "index",
            intersect: false,
            callbacks: {
              label: function(tooltipItem, data) {
                return (
                  Number(tooltipItem.yLabel)
                    .toFixed(0)
                    .replace(/./g, function(c, i, a) {
                      return i > 0 && c !== "." && (a.length - i) % 3 === 0
                        ? "." + c
                        : c;
                    }) + " VNĐ"
                );
              }
            }
          },
          hover: {
            mode: "nearest",
            intersect: true
          },
          scales: {
            xAxes: [
              {
                display: true,
                scaleLabel: {
                  display: false,
                  labelString: "Day"
                },
                ticks: {
                  autoSkip: true,
                  maxTicksLimit: 12
                },
                barThickness: 35, // number (pixels) or 'flex'
                maxBarThickness: 30 // number (pixels)
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  callback: function(value, index, values) {
                    return (
                      Number(value)
                        .toFixed(0)
                        .replace(/./g, function(c, i, a) {
                          return i > 0 && c !== "." && (a.length - i) % 3 === 0
                            ? "." + c
                            : c;
                        }) + " VNĐ"
                    );
                  }
                },
                stacked: false,
                display: true,
                scaleLabel: {
                  display: false,
                  labelString: "Visitors"
                }
              }
            ]
          }
        }
      },
      serviceId: 0,
      apartmentMonthlyUsageStatus: 0,
      totalReceivableList: [],
      totalPaidList: [],
      totalOpenList: [],
      dateFormat: null,
      isShowReportChart: true,
      eventdata: {
        start_datetime: null,
        end_datetime: null
      },
      optionsStart: {
        format: "MM/YYYY",
        useCurrent: false,
        maxDate: false
      },
      optionsEnd: {
        format: "MM/YYYY",
        useCurrent: true,
        minDate: false,
        maxDate: false
      },
      apartmentType: 1,
      detailReportTypeId: 1,
      isLoading: false
    };
  },
  watch: {
    COUNT_LIABILITIES_APARTMENT_MONTHLY_USAGE_DATA: function() {
      let data = this.COUNT_LIABILITIES_APARTMENT_MONTHLY_USAGE_DATA.data;
      this.column_fields = [];
      this.column_fields.push({
        key: "Tình trạng",
        label: "",
        class: "text-right"
      });
      this.columnData = [];
      this.columnData = [
        { id: 1, "Tình trạng": this.$t("reportLiabilitiesReport.paid") },
        { id: 3, "Tình trạng": this.$t("reportLiabilitiesReport.open") },
        { id: 2, "Tình trạng": this.$t("reportLiabilitiesReport.receivable") }
      ];
      let totalOpenInMonth = 0;
      let totalPaidInMonth = 0;
      let totalReceivalbeInMonth = 0;
      this.totalOpenList = [];
      this.totalPaidList = [];
      this.totalReceivableList = [];
      if (this.dateArray.length <= 0) {
        this.dateArray = data.date;
      }
      for (let i = 0, size = data.date.length; i < size; i++) {
        this.column_fields.push({
          key: data.date[i],
          label: data.date[i],
          class: "text-right"
        });
      }
      this.column_fields.push({
        key: "Tổng",
        label: "Tổng",
        class: "text-right"
      });
      for (let j = 0, size = data.open.length; j < size; j++) {
        totalOpenInMonth += data.open[j].total;
        this.totalOpenList.push(data.open[j]["total"]);
        this.columnData[1]["Tổng"] = utils.convertFormatNumberToMoney(
          totalOpenInMonth
        );
        this.columnData[1][
          `${data.date[j]}`
        ] = utils.convertFormatNumberToMoney(data.open[j].total);
      }
      for (let k = 0, size = data.paid.length; k < size; k++) {
        totalPaidInMonth += data.paid[k].total;
        this.totalPaidList.push(data.paid[k].total);
        this.columnData[0]["Tổng"] = utils.convertFormatNumberToMoney(
          totalPaidInMonth
        );
        this.columnData[0][
          `${data.date[k]}`
        ] = utils.convertFormatNumberToMoney(data.paid[k].total);
      }
      for (let l = 0, size = data.receivable.length; l < size; l++) {
        totalReceivalbeInMonth += data.receivable[l].total;
        this.totalReceivableList.push(data.receivable[l].total);
        this.columnData[2]["Tổng"] = utils.convertFormatNumberToMoney(
          totalReceivalbeInMonth
        );
        this.columnData[2][
          `${data.date[l]}`
        ] = utils.convertFormatNumberToMoney(data.receivable[l].total);
      }
      this.isLoading = false;
      this.setTotalVisitChartDate();
    }
  },
  computed: {
    ...mapGetters([
      "COUNT_LIABILITIES_APARTMENT_MONTHLY_USAGE_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },
  created() {
    let dateFormat = sessionStorage.getItem('projectDateViewOptions')
    if (!utils.isNull(dateFormat)) {
      this.isLoading = true;
      this.dateFormat = dateFormat.slice(3);
      this.optionsStart.format = this.dateFormat;
      this.optionsEnd.format = this.dateFormat;
      if (this.dateArray.length <= 0) {
        this.dateArray.push(moment(new Date()).format(this.dateFormat));
      }
      let filter = {
        params: {
          isCountReportLiabilities: "True",
          dateArray: this.dateArray,
          serviceId: this.serviceId,
          dateFormat: this.dateFormat,
          apartmentType: this.apartmentType
        }
      };
      this.COUNT_LIABILITIES_APARTMENT_MONTHLY_USAGE(filter).then(
        function(res) {
          this.isLoading = false;
        }.bind(this)
      )
      .catch(
        function(error) {
          this.isLoading = false;
        }.bind(this)
      );
    }
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onClickApartmentType: function(apartmentType) {
      this.isLoading = true;
      this.apartmentType = apartmentType;
      let filter = {
        params: {
          isCountReportLiabilities: "True",
          dateArray: this.dateArray,
          serviceId: this.serviceId,
          dateFormat: this.dateFormat,
          apartmentType: this.apartmentType
        }
      };
      this.COUNT_LIABILITIES_APARTMENT_MONTHLY_USAGE(filter)
        .then(
          function(res) {
            // Todo
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
      if (this.detailReportTypeId == 2) {
        this.$refs.detailedReportEachMonth.submit(apartmentType);
      } else if (this.detailReportTypeId == 3) {
        this.$refs.detailedReportAMonth.submit(apartmentType);
      }
    },
    myRowClickHandler: function(item) {
      let self = this;
      self.$router.push({
        name: "InvoiceList",
        params: {
          isViewDetail: "True",
          datasetLabel: item[0]["Tình trạng"],
          label: ""
        }
      });
    },
    getFormat: function() {
      if (utils.isNull(this.dateFormat)) {
        let dateFormat = "";
        let startDate = String(this.eventdata.start_datetime);
        startDate.includes("/")
          ? (dateFormat = "MM/YYYY")
          : (dateFormat = "MM-YYYY");
        return dateFormat;
      } else {
        return this.dateFormat;
      }
    },
    changeDateTime: function(event) {
      this.isLoading = true;
      if (this.eventdata.end_datetime == undefined) {
        this.optionsEnd.minDate = moment(
          this.eventdata.start_datetime,
          this.dateFormat
        );
      } else if (this.eventdata.start_datetime == undefined) {
        this.optionsStart.maxDate = moment(
          this.eventdata.end_datetime,
          this.dateFormat
        );
      } else {
        this.optionsStart.minDate = moment(
          this.eventdata.end_datetime,
          this.getFormat()
        ).subtract(11, "months");
        this.optionsStart.maxDate = moment();
        this.optionsEnd.minDate = moment(
          this.eventdata.start_datetime,
          this.getFormat()
        );
        this.optionsEnd.maxDate = moment(
          this.eventdata.start_datetime,
          this.getFormat()
        ).add(11, "months");
      }
      // Handle count liabilities apartment monthly usage
      this.dateArray = [];
      let dateArray = utils.getDatesBetweenTwoDate(
        this.eventdata.start_datetime,
        this.eventdata.end_datetime,
        this.dateFormat
      );
      this.dateArray = dateArray;
      if (this.dateArray.length > 0) {
        let filter = {
          params: {
            isCountReportLiabilities: "True",
            dateArray: this.dateArray,
            serviceId: this.serviceId,
            dateFormat: this.dateFormat,
            apartmentType: this.apartmentType
          }
        };
        this.COUNT_LIABILITIES_APARTMENT_MONTHLY_USAGE(filter)
          .then(
            function(res) {
              // Todo
            }.bind(this)
          )
          .catch(
            function(error) {
              this.isLoading = false;
            }.bind(this)
          );
      }
    },
    onLick: function(event, array) {
      let self = this;
      if (array.length != 0) {
        var datasetLabel = array[0]["_model"].datasetLabel;
        var label = array[0]["_model"].label;
        self.$router.push({
          name: "InvoiceList",
          params: {
            isViewDetail: "True",
            datasetLabel: datasetLabel,
            label: label
          }
        });
      } else {
        // console.log("You selected the background!");
      }
    },
    onExport: async function() {
      for (let i = 0, size = this.columnData.length; i < size; i++) {
        delete this.columnData[i]["id"];
      }
      let newKey = [];
      for (let i = 0, size = this.columnData.length; i < size; i++) {
        Object.keys(this.columnData[i]).forEach(keyName => {
          if (keyName != "Tình trạng") {
            if (typeof this.columnData[i][keyName] == "string") {
              this.columnData[i][keyName] = this.columnData[i][keyName].replace(
                /[^\d-]/g,
                ""
              );
            }
          }
        });
        newKey.push({
          status: this.columnData[i]["Tình trạng"],
          total: this.columnData[i]["Tổng"]
        });
      }
      let newData = [];
      for (let i = 0, size = this.columnData.length; i < size; i++) {
        Object.keys(this.columnData[i]).forEach(keyName => {
          if (keyName != "Tình trạng") {
            this.columnData[i][keyName] = parseInt(this.columnData[i][keyName]);
          }
        });
        newData.push(this.columnData[i]);
      }
      let total = [];
      for (let j = 0, size = newData.length; j < size; j++) {
        Object.keys(newData[j]).forEach(keyName => {
          if (keyName == "Tổng") {
            total = newData[j][keyName];
            delete newData[j]["Tổng"];
            newData[j]["Tổng"] = total;
          }
        });
      }
      // export json to Worksheet of Excel
      // only array possible
      var report = XLSX.utils.json_to_sheet(newData);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)
      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel
      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, report, "report"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')
      var wscols = [
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 }
      ];
      report["!cols"] = wscols;
      // export Excel file
      XLSX.writeFile(wb, "Report Liabilities.xlsx"); // name of the file is 'book.xlsx'
    },
    viewDetailReport: function(row) {
      // To do
    },
    onSelectReportType: function(reportType) {
      this.detailReportTypeId = 1;
      if (reportType.id == "2") {
        this.isShowReportChart = false;
      } else {
        this.isShowReportChart = true;
      }
    },
    onSelectDetailReportType: function(detailReportType) {
      this.detailReportTypeId = parseInt(detailReportType.id);
    },
    onSelectServiceType: function(serviceType) {
      this.isLoading = true;
      this.serviceId = serviceType.id;
      let filter = {
        params: {
          isCountReportLiabilities: "True",
          dateArray: this.dateArray,
          serviceId: this.serviceId,
          dateFormat: this.dateFormat,
          apartmentType: this.apartmentType
        }
      };
      this.COUNT_LIABILITIES_APARTMENT_MONTHLY_USAGE(filter)
        .then(
          function(res) {
            // Todo
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    setTotalVisitChartDate: function() {
      let labels, datasets;
      labels = this.dateArray;
      datasets = [
        {
          label: this.$t("reportLiabilitiesReport.paid"),
          fill: false,
          backgroundColor: "dodgerblue",
          borderColor: "dodgerblue",
          data: this.totalPaidList.length > 0 && this.totalPaidList
        },
        {
          label: this.$t("reportLiabilitiesReport.receivable"),
          fill: false,
          backgroundColor: "orange",
          borderColor: "orange",
          data: this.totalReceivableList.length > 0 && this.totalReceivableList
        },
        {
          label: this.$t("reportLiabilitiesReport.open"),
          fill: false,
          backgroundColor: "green",
          borderColor: "green",
          data: this.totalOpenList.length > 0 && this.totalOpenList
        }
      ];
      let data = Object.assign({}, this.totalVisitChartConfig);
      data.data.labels = labels;
      data.data.datasets = datasets;
      data.options.scales.xAxes[0].barThickness =
        this.dateArray && this.dateArray.length == 12 ? 25 : 35;
      data.options.scales.xAxes[0].maxBarThickness =
        this.dateArray && this.dateArray.length == 12 ? 20 : 30;
      this.totalVisitChartConfig = data;
    },
    ...mapActions([
      "COUNT_LIABILITIES_APARTMENT_MONTHLY_USAGE"
    ])
  },
  mounted() {
    this.eventdata.start_datetime = moment();
    this.eventdata.end_datetime = moment();
  },
  components: {
    "lte-button": LTEButton,
    "lte-chart": LTEChart,
    "date-picker": datePicker,
    // 'lte-date-range-picker2': DateRangePicker2,
    "lte-select2": Select2,
    "detailed-report-by-each-month": DetailedReportByEachMonth,
    "detailed-report-of-each-unit-for-a-month": DetailedReportOfEachUnitForAMonth
  }
};
</script>
<style scoped>
.btn-change-apartment-type {
  background-color: #fff;
  display: inline-block;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 2px 2px #888888;
}
.btn-change-apartment-type-selected {
  background-color: #00c0ef;
  display: inline-block;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 2px 2px #888888;
  color: #fff;
}
.btn-change-apartment-type:hover {
  background-color: #e5e5e59d;
}
</style>



// WEBPACK FOOTER //
// src/views/Report/LiabilitiesReport.vue